import { SortableContainer } from "react-sortable-hoc";
import { usePunditUserContext } from "@circle-react/contexts";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import { useLgScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { SpaceGroup } from "./SpaceGroup";
import { SpaceGroupListView } from "./SpaceGroupListView";

export interface SpaceGroupListProps {
  onSpaceSortEnd: any;
  spaceGroupDragProperties: any;
  spaceGroupWithSpaces: any[];
}

export const SpaceGroupList = SortableContainer(
  ({
    spaceGroupWithSpaces,
    onSpaceSortEnd,
    spaceGroupDragProperties,
  }: SpaceGroupListProps) => {
    const { currentCommunityMember } = usePunditUserContext();
    const isAdmin = isCommunityAdmin(currentCommunityMember);
    const isLargeScreen = useLgScreenMediaQuery();
    const shouldDisableDragAndDropForSpaceGroups = !isAdmin || !isLargeScreen;

    return (
      <SpaceGroupListView>
        {spaceGroupWithSpaces.map((spaceGroup, index) => (
          <SpaceGroup
            index={index}
            disabled={shouldDisableDragAndDropForSpaceGroups}
            position={index}
            key={spaceGroup.id}
            spaceGroup={spaceGroup}
            spaceGroupDragProperties={spaceGroupDragProperties}
            onSpaceSortEnd={onSpaceSortEnd}
          />
        ))}
      </SpaceGroupListView>
    );
  },
);
